/**
 * Copyright (C) Paul Sarando
 * Distributed under the Eclipse Public License (http://www.eclipse.org/legal/epl-v10.html).
 */

export enum LanguageEnum {
    ENGLISH = "english",
    QUENYA = "quenya",
    SINDARIN = "sindarin",
}
